/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { SxProps, Theme } from "@mui/material";

export const arrayUtils = {
  getArrayInterSection: function getArrayInterSection<T>(a: Array<T>, b: Array<T>) {
    const bAsSet = new Set(b);
    return a.filter((item) => bAsSet.has(item));
  },
  getArraysIntersect: function getArraysIntersect<T>(a: Array<T>, b: Array<T>) {
    return arrayUtils.getArrayInterSection(a, b).length > 0;
  },
};

export function capitalizeFirstLetter(input: string): string {
  if (!input) return input;
  return input[0].toUpperCase() + input.slice(1);
}

export const sxToArray = (sx?: SxProps<Theme>) => {
  if (!sx) {
    return [];
  }
  return Array.isArray(sx) ? sx : [sx];
};

export function parseIdFromIri(iri: string): number {
  const match = iri.match(/\/(\d+)$/);

  if (!match) {
    throw new Error(`Invalid IRI: ${iri}`);
  }

  return Number(match[1]);
}
